import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {SelectNew} from '../select-new/select-new';

type Props = FieldProps & {
    selectValues: any[];
    isInline?: boolean;
};

export function ReduxFormSelectNew(props: Props) {
    const {input, ...rest} = props;

    return <SelectNew {...input} {...rest} isTiny={true} />;
}
